(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/draw-widgets/assets/javascripts/widget-wager-container.js') >= 0) return;  svs.modules.push('/components/pool-betting/draw-widgets/assets/javascripts/widget-wager-container.js');
"use strict";

const useGetWagerDraw = svs.components.tipsen.hooksWager.useGetWagerDraw;
const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const _svs$components$sport = svs.components.sport.tipsenShared,
  drawStateEnums = _svs$components$sport.drawStateEnums,
  getDrawStateEnum = _svs$components$sport.getDrawStateEnum;
const WidgetWagerContainer = _ref => {
  let wagerId = _ref.wagerId,
    className = _ref.className;
  const _useGetWagerDraw = useGetWagerDraw({
      wagerId
    }),
    draw = _useGetWagerDraw.draw;
  const drawState = getDrawStateEnum(draw === null || draw === void 0 ? void 0 : draw.drawStateId);
  const isLive = drawState === drawStateEnums.LIVE;
  const classNames = ['draw-widget-container'];
  className && classNames.push(className);
  if (isLive) {
    return React.createElement(WidgetArea, {
      className: classNames.join(' '),
      widgetArea: "drawLive"
    });
  }
  return React.createElement(WidgetArea, {
    className: classNames.join(' '),
    widgetArea: "drawNotLive"
  });
};
setGlobal('svs.components.poolBetting.drawWidgets.WidgetWagerContainer', WidgetWagerContainer);

 })(window);